module.exports = __webpack_public_path__ + "img/photo_2024-03-15_21-05-36.4fbc80a7.jpg";